/**
 * Login sonrası veya "beni hatırla" seçeneğinde authType'ı kalıcı olarak kaydeder.
 * @param {"SAML"|"OTP"} authType
 */
export function setLastAuthType(authType) {
  localStorage.setItem("lastAuthType", authType);
  localStorage.removeItem("tmpLastAuthType");
}

/**
 * Redirect öncesi authType'ı geçici alana taşır.
 * Kullanıcı URL'yi tekrar girerse Landing Page'e düşer.
 * @param {"SAML"|"OTP"} authType
 */
export function shiftAuthTypeToTmp(authType) {
  localStorage.setItem("tmpLastAuthType", authType);
  localStorage.removeItem("lastAuthType");
}

/**
 * Landing Page'e düşüldüğünde tmpLastAuthType → lastAuthType'a restore eder.
 */
export function restoreAuthTypeFromTmp() {
  const lastAuthType = localStorage.getItem("lastAuthType");
  const tmpLastAuthType = localStorage.getItem("tmpLastAuthType");
  if (!lastAuthType && tmpLastAuthType) {
    localStorage.setItem("lastAuthType", tmpLastAuthType);
    localStorage.removeItem("tmpLastAuthType");
  }
}
